import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { Severity } from '../../../../common/enums/Severity';
import { TABLE_LAYOUT_SX } from '../../constants/constants';
import { InstancesCounters } from '../models/valueObjects/InstancesCounters';
import { Issue } from '../models/valueObjects/Issue';
import { InstancesChart } from './InstancesChart';
import { IssuesChart } from './IssuesChart';
import { Summary } from './Summary';

type Props = {
  issueGroups: Record<Severity, Issue[]>;
  instanceCounters: InstancesCounters;
};

export const Overview = ({ issueGroups, instanceCounters }: Props) => {
  return (
    <Table data-print="table-layout" sx={TABLE_LAYOUT_SX}>
      <TableBody>
        <TableRow>
          <TableCell>
            <Summary counters={instanceCounters} />
          </TableCell>
          <TableCell>
            <IssuesChart groups={issueGroups} />
          </TableCell>
          <TableCell>
            <InstancesChart counters={instanceCounters} />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};
